import uniq = require('lodash/uniq'); // tslint:disable-line: no-require-imports
import compact = require('lodash/compact'); // tslint:disable-line: no-require-imports

export interface PathParts {
	dir: string;
	name: string;
	ext: string;
}

export interface ModificationData {
	modifying: ConfigEditor.ModificationEntity;
	modification: ConfigEditor.AssetsModification;
}

export function getPathParts(path: string): PathParts {
	const parts = path.split('/');
	const filePart = parts.pop();
	const dotIndex = filePart.indexOf('.');
	return {
		dir: parts.join('/'),
		name: filePart.substring(0, dotIndex),
		ext: filePart.substring(dotIndex + 1),
	};
}

function getFileExtension(file: string) {
	const dotIndex = file.lastIndexOf('.');
	return file.substr(dotIndex);
}

export function isBinaryFile(assetPath: string): boolean {
	const binaryExtensions = ['.pdf', '.png', '.jpg', '.jpeg'];
	const assetFileExtension = getFileExtension(assetPath);
	return binaryExtensions.some(be => assetFileExtension === be);
}

type BinaryMimeType = 'application/pdf' | 'image/png' | 'image/jpeg';

export function getBinaryMimeType(fileName: string): BinaryMimeType {
	switch (getFileExtension(fileName)) {
		case '.pdf': return 'application/pdf';
		case '.png': return 'image/png';
		case '.jpg': return 'image/jpeg';
		case '.jpeg': return 'image/jpeg';
		default: return null;
	}
}

export function getAdjustedFontStyle(initial: number, adjustment: number): { fontSize: string } {
	return {
		fontSize: `${initial + adjustment}px`,
	};
}

function getProduct(path: string) {
	const PRODUCT_REGEX = '^products\/([^\/]+)\/';
	const matches: string[] = path.match(new RegExp(PRODUCT_REGEX));
	return matches ? matches[1] : null;
}

export function getProducts(assetFiles: ConfigEditor.AssetFiles) {
	return uniq(compact(Object.keys(assetFiles).map(getProduct)));
}

function getExposureForProduct(productName: string, path: string) {
	const EXPOSURE_REGEX = '^products\/' + productName + '\/policy\/exposures\/([^\/]+)\/';
	const matches: string[] = path.match(new RegExp(EXPOSURE_REGEX));
	return matches ? matches[1] : null;
}

export function getExposuresForProduct(productName: string, assetFiles: ConfigEditor.AssetFiles) {
	return uniq(compact(Object.keys(assetFiles).map(path => {
		return getExposureForProduct(productName, path);
	})));
}

function getPerilForExposure(productName: string, exposureName: string, path: string) {
	const PERIL_REGEX = '^products\/' + productName + '\/policy\/exposures\/' + exposureName + '\/perils\/([^\/]+).json';
	const matches: string[] = path.match(new RegExp(PERIL_REGEX));
	return matches ? matches[1] : null;
}

export function getPerilsForExposure(productName: string, exposureName: string, assetFiles: ConfigEditor.AssetFiles) {
	return uniq(compact(Object.keys(assetFiles).map(path => {
		return getPerilForExposure(productName, exposureName, path);
	})));
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/components/config-editor/_util.ts